import OopsPage from "@pageContent/OopsPage";

const Error = () => <OopsPage />;

export default Error;
